import store from "@/store";
import { CustomAlertExit } from "@/assets/js/util.js";
import i18n from "@/i18n";

/**
 * Handle logout with confirmation dialog
 */
export function handleLogout() {
  CustomAlertExit(
    i18n.global.t("common.alertLogoutConfirm"),
    true,
    () => {
      store.dispatch("logout");
    },
    null
  );
}
